
class Map {
  constructor (id) {
    this.myMap = null;
    this.myPlacemark = null;
    this.id = id;

    this.longitude = $('#map').data('longtitude');
    this.latitude = $('#map').data('latitude');
    this.name = $('#map').data('name');


    if (window.ymaps) {
      window.ymaps.ready(() => {
        this.init()

      })
    }
  }

  resize () {
    if (this.myMap) {
      // console.log(this.myMap);
      this.myMap.container.fitToViewport()
    }
  }

  init () {
    let HintLayout = window.ymaps.templateLayoutFactory.createClass('<div class=\'ya-hint\'>{{ properties.content }}</div>')

    this.myMap = new window.ymaps.Map(this.id, {
      center: [this.longitude, this.latitude],
      zoom: 15,
      controls: []
    });
    this.myMap.controls.add('zoomControl', {
      float: 'none',
      position: {top: 150, left: 10}
    });
    this.myPlacemark = new window.ymaps.Placemark(
      [this.longitude, this.latitude],
      {
        content: this.name
      },
      {
        hintLayout: HintLayout,
        iconLayout: 'default#image',
        iconImageHref: '/static/images/site-constructor/map-markers/gk.svg',
        iconImageSize: [95, 50],
        iconImageOffset: [-47.5, -50]
      }
    )

    this.myPlacemark.options.set('zIndex', 700)
    this.myMap.behaviors.disable('scrollZoom')
    this.myMap.geoObjects.add(this.myPlacemark)
  }

  // addObjects(){
  //   let HintLayout = window.ymaps.templateLayoutFactory.createClass('<div class=\'ya-hint\'>{{ properties.content }}</div>')
  //
  //   let objects = new window.ymaps.GeoObjectCollection()
  //   let len = this.infrastructures.length
  //
  //   for (let i = 0; i < len; i++) {
  //     objects.add(new window.ymaps.Placemark(
  //       [this.infrastructures[i].latitude, this.infrastructures[i].longitude],
  //       {
  //         content: this.infrastructures[i].title
  //       },
  //       {
  //         hintLayout: HintLayout,
  //         iconLayout: 'default#image',
  //         iconImageHref: this.infrastructures[i].marker_type.image,
  //         iconImageSize: [35, 35],
  //         iconImageOffset: [-17.5, -17.5]
  //       }
  //       )
  //     )
  //   }
  //
  //   this.myMap.geoObjects.add(objects)
  // }
}

export default Map



// WEBPACK FOOTER //
// ./resources/assets/js/site-constructor/map/index.js